import { render, staticRenderFns } from "./teamwork.vue?vue&type=template&id=72c3f387&"
import script from "./teamwork.vue?vue&type=script&lang=js&"
export * from "./teamwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports